/* Real chat links remain usable without JS; the selector shows one region. */
(() => {
  document.querySelectorAll('[data-contact-hub]').forEach(hub => {
    const selector = hub.querySelector('[data-contact-selector]');
    const panels = [...hub.querySelectorAll('[data-contact-region]')];
    if (!selector || !panels.length) return;
    const show = (value, scroll = false) => {
      const selected = panels.find(panel => panel.dataset.contactRegion === value);
      if (!selected) return;
      panels.forEach(panel => { panel.hidden = panel !== selected; });
      selector.value = value;
      if (scroll) requestAnimationFrame(() => selected.scrollIntoView({ block: 'start' }));
    };
    const fromHash = (hash, scroll = false) => {
      let id;
      try { id = decodeURIComponent(hash.replace(/^#/, '')); } catch { return false; }
      const panel = panels.find(item => item.id === id || [...item.querySelectorAll('[id]')].some(el => el.id === id));
      if (!panel) return false;
      show(panel.dataset.contactRegion, scroll);
      return true;
    };
    const country = document.body.dataset.country;
    if (!fromHash(location.hash, true)) show(country === 'CN' ? 'wechat' : country === 'MY' ? 'malaysia' : 'singapore');
    selector.closest('.ch-selector').hidden = false;
    selector.addEventListener('change', () => show(selector.value));
    window.addEventListener('hashchange', () => fromHash(location.hash, true));
    document.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (anchor) fromHash(anchor.getAttribute('href'));
    });
  });
  document.querySelectorAll('.ch-contact [data-copy-wechat]').forEach(button => {
    const channel = button.closest('.ch-channel--wechat');
    const identity = channel?.querySelector('[data-wechat-id]');
    const status = channel?.querySelector('[data-copy-status]');
    if (!identity || !status) return;
    const copyLabel = button.textContent;
    button.hidden = false;
    button.addEventListener('click', async () => {
      const value = identity.textContent.trim();
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(value);
        status.textContent = button.dataset.copySuccess;
        button.textContent = button.dataset.copySuccess;
      } catch {
        button.textContent = copyLabel;
        identity.focus({ preventScroll: true });
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(identity);
        selection?.removeAllRanges();
        selection?.addRange(range);
        status.textContent = button.dataset.copyFailure;
      }
    });
  });
})();
